import { useSyncExternalStore } from 'react'
import { useMetroMapStore } from './useMetroMapStore'
import type { MetroMapState } from './metroMapStore'

/**
 * Read-handle to the RouteCard origin/destination slice of the
 * MetroMap store. Re-renders the consumer only when `routeSelection`
 * itself changes (Object.is bailout via `useSyncExternalStore`), so
 * unrelated state churn — e.g., `selectedStation`, theme — does not
 * thrash route-card consumers. Throws (via `useMetroMapStore`) if used
 * outside `<MetroMapStoreProvider>`.
 */
export function useRouteSelection(): MetroMapState['routeSelection'] {
  const store = useMetroMapStore()
  return useSyncExternalStore(store.subscribe, () => store.getState().routeSelection)
}
